import { Injectable } from '@angular/core';
import { ApiService, Resource } from './api.service';
import { Subject } from 'rxjs';

@Injectable()
export class MenuService {

  public menuItems: MenuItem[];
  public updated = new Subject<MenuItem[]>();
  constructor(private readonly api: ApiService) {
    this.menuItems = [];
  }

  public populate() {

    this.api.resource(Resource.MENU).list().subscribe((data: Array<MenuItem>) => { this.build(data); }, err => { console.log('menu error'); });
  }

  public build(items: MenuItem[]) {
    this.menuItems = items;
    this.updated.next(this.menuItems);
  }

  public getMenu() {
    return this.menuItems;
  }

}

export interface MenuItem {
  text: string;
  heading?: boolean;
  link?: string;     // internal route links
  elink?: string;    // used only for external links
  target?: string;   // anchor target="_blank|_self|_parent|_top|framename"
  icon?: string;
  alert?: string;
  submenu?: Array<MenuItem>;
}
